<template>


  <t-dialog-form :generalErrors="generalErrors" title="Detalhe da Etapa"
                 :ok-text="onlyView ? 'Fechar' : 'Salvar'"
                 :status="status"
                 @hidden="closeDialog" large
                 :command="onlyView ? 'view' : 'update'"
                 :id="id"
                 ref="dialog_form" @onSubmit="onSubmit">



    <template>

      <StepCopyDataDialog :primary-key="form.productionOrderBatchStepId" @onSubmit="onSubmitStepCopy"/>

      <b-card class="border">

        <b-card-title>Dados Básicos</b-card-title>

        <b-row>

          <t-input highlight fixed label="Ordem Fabricação" v-model="form.productionOrderCodeLabel" cols="2"/>

          <t-input fixed label="Denominação da Etapa" v-model="form.name" cols="4"/>

          <t-input fixed label="Status da Etapa" select :options="StatusStepType.list" v-model="form.statusStep"
                   cols="3"/>

          <t-input fixed label="Tipo" v-model="typeStep" cols="3"/>

        </b-row>

        <b-row>

          <t-input fixed label="Grupo(s)" v-model="form.responsibleName" cols="6"/>

          <t-input fixed label="Operador" v-model="form.operator" cols="6"/>

        </b-row>

        <b-row>

          <t-input fixed label="Início" v-model="form.shotLastStart" datetime cols="4"/>

          <t-input fixed label="Término" v-model="form.shotLastFinish" datetime cols="4"/>

          <t-input v-if="form.statusStep === StatusStepType.type.DONE" fixed label="Tempo finalização (min)"
                   v-model="form.shotLastTimeOrNow" cols="4"/>

          <t-input v-else-if="form.statusStep === StatusStepType.type.CURRENT" fixed label="Tempo decorrido (min)"
                   v-model="form.shotLastTimeOrNow" cols="4"/>

          <t-input v-else fixed label="Tempo (min)" cols="4"/>

        </b-row>

      </b-card>

      <b-card class="border mt-2">

        <t-msg warning v-if="lastNonConformanceRuleName !== ''">Regra de maior prioridade aplicada: <br/><h5>
          {{ lastNonConformanceRuleName }}</h5></t-msg>


        <b-card-title>Campos de Preenchimento</b-card-title>

        <div class="d-flex align-items-end justify-content-end" v-if="form.enableCopyOtherStep && !onlyView">
          <b-link @click="openDialogForm('modal-copy-data-other-step')">
            <b-icon-files class="mr-2"/>
            Copiar dados
          </b-link>
        </div>

        <t-page-form-field-customized
            ref="fieldsGeneral"
            :command="onlyView ? 'view' : 'update'"
            :status="status"
            :fields-customizable="entityFieldCustomized('processFlowStep')"
            :primary-key="productionOrderBatchStepId" :foreign-key="form.processFlowStepId"
            :non-conformance-fields="lastNonConformanceFields"
            :busy="!pageIsLoaded"
            primary-key-column="productionOrderBatchStepId" foreign-key-column="processFlowStepId"
        />

        <t-input textarea :fixed="onlyView" label="Observações" v-model="form.note"/>

      </b-card>

      <b-card class="border mt-2">

        <b-card-title>Imagens capturadas</b-card-title>

        <ProductionOrderStepFile :only-view="onlyView || status === 'sending'" type-image :foreign-key="productionOrderBatchStepId"
                                 message-not-record="Nenhuma imagem capturada nesta etapa"/>

      </b-card>

    </template>



  </t-dialog-form>


</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin";
import pageFormMixin from "@/mixins/page/pageFormMixin";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import StatusStepType from "@/model/types/modules/production/StatusStepType";
import FlowStepNotSequenceActionType from "@/model/types/modules/production/FlowStepNotSequenceActionType";
import ProductionOrderStepFile from "@/views/modules/production/ProductionOrder/ProductionOrderStepFile";
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import ProductionOrderStepService from "@/services/modules/production/ProductionOrderStep.service";
import StepCopyDataDialog from "@/views/modules/production/ProductionOrder/components/StepCopyDataDialog.vue";
import ui from "@/assets/scripts/ui";

export default {
  name: 'ProductionOrderStepDialog',
  components: {ProductionOrderStepFile,tDialogForm, StepCopyDataDialog},
  mixins: [pageDefaultMixin, pageFormMixin],
  data() {
    return {
      StatusStepType,
      FlowStepNotSequenceActionType,
      id: "modal-production-order-step-detail",
      pageIsLoaded: false,
      path: "production/order-step", //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      fieldKey: "productionOrderBatchStepId",
      form: {},
      fieldsCustomizable: [
        {
          entity: "processFlowStep",
          foreignKeyColumn: "processFlowStepId",
          path: "production/process-flow-step",
          fields: [],
        }
      ],
      lastNonConformanceRuleName: "",
      lastNonConformanceFields: [],
      typeStep: "",
    }
  },
  props: {
    show: Boolean,
    onlyView: Boolean,
    productionOrderBatchStepId: {
      type: Number,
      required: true,
    },
  },

  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await crudGeneral.getById(this.path, this.productionOrderBatchStepId).then(
          async response => {

            this.form = response.data

            if (this.form.stepSequential) {
              this.typeStep = 'Sequêncial'
            } else if (this.form.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL) {
              this.typeStep = 'Paralela'
            } else if (this.form.typeActionNotSequential === FlowStepNotSequenceActionType.type.FINAL_INSPECTION_SHIPPING) {
              this.typeStep = 'Inspeção Expedição'
            } else {
              this.typeStep = 'Correção'
            }

            if (this.form.lastNonConformanceId !== undefined && this.form.lastNonConformanceId > 0) {
              this.lastNonConformanceRuleName = this.form.lastNonConformanceAppliedRuleName
              this.lastNonConformanceFields = this.form.lastNonConformance.fields
            }

            if (this.fieldsCustomizable.length > 0) {

              for (const entity of this.fieldsCustomizable) {
                await this.getFieldsCustomizable(entity.entity)
              }

            }

          }
      ).catch(error => this.responseError(error))

      this.pageIsLoaded = true


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    closeDialog() {
      this.$emit("onClose")
    },

    async onSubmitStepCopy(step) {

      //Troca os campos pela etapa que deseja copiar
      this.form.fieldsCustomized = step.fieldsCustomized

      //Copia os dados de observações
      this.form.note = step.note

      //Obtem todos os campos e injeta os campos copiados.
      await this.getAllFieldsCustomizable();


      //Informa que foi copiado com sucesso
      ui.toast(this, "Informação", "Dados copiados com sucesso!")

    },

    async onSubmitContinued() {

      this.command = 'update'
      this.status = "sending"

      await this.setSending(
          this.form[this.fieldKey],
          () => {
            this.$bvModal.hide(this.id)
            this.$emit("onSubmit",this.form) //Envia o proprio formulário pois é mais completo
          },
      )


    },

    async onSubmit() {

      if (this.onlyView) {
        this.$emit("onClose")
      } else {

        this.status = "sending"

        //Verifica se alguma regra será aplicada
        await this.injectFieldsForm()
        await ProductionOrderStepService.checkRules(
            this,
            this.form,
            this.onSubmitContinued,
            this.onSubmit,
            () => {
              this.status = ""
            },
            (alternativeChosen) => {
              this.form.alternativeChosen = alternativeChosen
            },
            (typeNonConformanceChosen) => {
              this.form.typeNonConformanceChosen = typeNonConformanceChosen
            },
        )



      }



    },

    //--------------------------------------------------------------------------------------
  },


  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },

}
</script>